import { Container } from '@seek/ai-elements';
import { useTranslations } from '@vocab/react';
import { Box, Stack } from 'braid-design-system';
import { useMemo, type ComponentProps } from 'react';

import translations from './.vocab';
import { CareerFeedAIHeading } from './CareerFeedAIHeading';
import { useCareerFeedAIAssistant } from './hooks/useCareerFeedAIAssistant';

const useHeading = () => {
  const { progress } = useCareerFeedAIAssistant();
  const { t } = useTranslations(translations);

  return useMemo(() => {
    switch (progress) {
      case 'initial':
        return t('Want better job matches?');
      case 'gatheringRefinement':
      case 'collectGeneralRequirementsAtLast':
        return t('Define your preferences');
      case 'recsRefined':
      case 'recsRefined-withPersistedData':
        return t('Refined for you');
    }
  }, [progress, t]);
};

export const CareerFeedAIAssistantContainer = ({
  showHeading,
  children,
}: {
  showHeading?: boolean;
  children: ComponentProps<typeof Stack>['children'];
}) => {
  const headingText = useHeading();

  return (
    <Box display="flex" flexDirection="column" width="full">
      <Container borderWidth="standard" padding="medium">
        <Stack space="medium">
          {showHeading && <CareerFeedAIHeading headingText={headingText} />}
          {children}
        </Stack>
      </Container>
    </Box>
  );
};
